const ufeApi = require('services/api/ufeApi');
const ATG_URL = '/api/secure/validatePasswordToken';
const AUTH_URL = '/api/auth/v1/validatePasswordToken';

// https://jira.sephora.com/wiki/display/ILLUMINATE/Validate+Password+Token+API

function validatePasswordToken(securityToken) {
    const { isAuthServiceResetPassEnabled } = Sephora.configurationSettings;

    let URL = ATG_URL;
    let headers = {};

    if (isAuthServiceResetPassEnabled) {
        URL = AUTH_URL;
        headers = {
            'Content-type': 'application/json',
            'x-requested-source': 'web'
        };
    }

    return ufeApi
        .makeRequest(URL, {
            method: 'POST',
            body: JSON.stringify({ securityToken }),
            headers
        })
        .then(data => (data.errorCode || data.errors ? Promise.reject(data) : data));
}

module.exports = validatePasswordToken;
